import { PlanType } from 'src/@types/feature';
import { formatPriceTextOnly } from './priceFormatter';
import { PlanPrice, UserPlan } from 'src/resources/api/subscription/types.api';

export const staticPlanData = [
  {
    planLevel: 20,
    planImage: 'https://res.cloudinary.com/carbonclick/image/upload/f_auto/v1689063541/Merchant%20Portal/planting-trees_eaixka.jpg',
  },
  {
    planLevel: 30,
    planImage: 'https://res.cloudinary.com/carbonclick/image/upload/f_auto/v1689063542/Merchant%20Portal/caucasian-man-and-american-woman_t51wez.jpg',
  },
  {
    planLevel: 40,
    planImage: 'https://res.cloudinary.com/carbonclick/image/upload/f_auto/v1689063542/Merchant%20Portal/panoramic-view-of-wind-turbine-and-solar-panels_buzgt4.jpg',
  },
];

export const getPlanPrice = (selectedBtn: string, selectedCurrency: string, plan: UserPlan) => {
  if (!selectedBtn || !selectedCurrency) {
    return;
  }

  let tempPlanPrice = plan?.prices?.find((price: PlanPrice) =>
    price?.recurringInterval === selectedBtn &&
    price?.currency === selectedCurrency?.toLowerCase()
  );

  if (tempPlanPrice?.unitAmount) {
    tempPlanPrice = { ...tempPlanPrice, unitAmount: tempPlanPrice?.unitAmount * 0.01 }
  }

  return tempPlanPrice;
};

export const getPriceSavingInYear = (planName: number, selectedCurrency: string, plan: UserPlan) => {
  const monthPrice = getPlanPrice(PlanType.MONTHLY, selectedCurrency, plan);
  const yearPrice = getPlanPrice(PlanType.ANNUAL, selectedCurrency, plan);

  if (plan?.planLevel === planName && monthPrice && yearPrice) {
    const res = ((monthPrice?.unitAmount * 12) - yearPrice?.unitAmount);

    const formattedMonthlyPrice = formatPriceTextOnly({
      currency: selectedCurrency,
      symbol: '',
      value: res,
      zeroDecimalCurrency: false,
    });

    return `Save ${formattedMonthlyPrice} per year`;
  }
}
